import React from 'react';
import img from '../images/image2.webp';

const Intro = () => {
  return (
    <section className="mx-auto max-w-7xl px-4 py-20 md:px-6" id="about">
      <div className="grid items-center gap-10 lg:grid-cols-[0.92fr_1.08fr]">
        <div data-aos="fade-right">
          <div className="overflow-hidden rounded-[2rem] border border-white/70 bg-white/78 p-3 shadow-xl shadow-stone-900/10 backdrop-blur">
            <img
              alt="Traditional Thai massage room"
              className="h-[420px] w-full rounded-[1.5rem] object-cover"
              src={img}
            />
          </div>
        </div>

        <div data-aos="fade-left" data-aos-delay="150">
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.28em] text-stone-500">
            Authentic Experience
          </p>
          <h2 className="font-cyclin text-4xl font-bold leading-tight text-slate-950 md:text-5xl">
            Traditional Thai massage focused on relaxation, mobility and care.
          </h2>

          <p className="mt-6 text-lg leading-8 text-stone-700">
            Our treatments combine acupressure, stretching and rhythmic body
            work to release tension, improve circulation and help you recover
            both physically and mentally.
          </p>

          <p className="mt-4 text-lg leading-8 text-stone-700">
            Certified practitioners deliver an authentic Thai massage
            experience in a calm setting, whether you want a restorative foot
            massage, deeper muscle relief or a full body session.
          </p>

          <div className="mt-8 flex flex-wrap gap-4">
            <div className="rounded-2xl border border-amber-200/80 bg-amber-50/80 px-5 py-4 text-sm font-semibold text-amber-900">
              Certified practitioners
            </div>
            <div className="rounded-2xl border border-stone-200 bg-white/85 px-5 py-4 text-sm font-semibold text-stone-700">
              Daily opening hours: 9:00 AM to 9:00 PM
            </div>
          </div>

          <div className="mt-8 flex flex-col gap-4 sm:flex-row">
            <a
              href="https://wa.me/+66641831185"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center rounded-full bg-stone-900 px-7 py-4 font-cyclin text-lg font-bold text-white transition hover:bg-stone-800"
            >
              Contact on WhatsApp
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=100094543849028"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center rounded-full border border-stone-300 bg-white/85 px-7 py-4 text-lg font-semibold text-stone-900 transition hover:bg-white"
            >
              Follow on Facebook
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
